import { Div, Text, TextLink } from 'ui'
import useResponsive from 'utils/hooks/useResponsive'
import { useTranslation } from 'react-i18next'


const Faqs = () => {

  const { t } = useTranslation()
  const { isMobile } = useResponsive()

  return (
    <Div
        width='90%'
        textAlign='center'
        margin={isMobile
          ? '24px auto 0'
          : '64px auto 0'
        }
      >
        <Text
          as='span'
          size={isMobile ? 'sm' : 'base'}
        >
          {t('anyQuestions')}
        </Text>
        {' '}
        <TextLink
          isInline
          color='white'
          size={isMobile ? 'sm' : 'base'}
          to='/faqs'
        >
          {t('faqs').toLowerCase()}
        </TextLink>
      </Div>
  )
}

export default Faqs